module.exports = __webpack_public_path__ + "static/media/icon_new.efaa850a.svg";